import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function LeadershipSection({
  title,
  paragraph,
  leaderName,
  designation,
  linkedinImg,
  linkedinUrl,
  vectorClass,
  leaderImage,
}) {
  return (
    <>
      <Container fluid className="practiceLeadership">
        <div className="practiceLeadershipSection">
          <Row>
            <Col sm={6}>
              <div className="practiceLeaderShipTitle">{title}</div>
              <div className="practiceLeaderShipPara">{paragraph}</div>
              <Row>
                <div className="leaderName">{leaderName}</div>
              </Row>
              <Row>
                <div className="leaderDesignation col-6 col-md-4">
                  {designation}
                </div>
                <div className="linkedinIn col-8 col-md-1 offset-md-10 top-2">
                  <a
                    href={linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={linkedinImg} alt="LinkedIn" />
                  </a>
                </div>
                <div className={vectorClass}></div>
              </Row>
            </Col>
            <Col sm={4} className="ImgContainer">
              <img className="tammyImg" src={leaderImage} alt={leaderName} />
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export function LeaderProfile({ imageSrc, altText, placeholderText }) {
  return (
    <>
      <Row>
        <img className="Profile" src={imageSrc} alt={altText} />
      </Row>
      <Row>
        <p className="profilePara">{placeholderText}</p>
      </Row>
    </>
  );
}

export function LeaderDetails({
  name,
  designation,
  linkedinImg,
  linkedinUrl,
  playButtonImg,
}) {
  return (
    <>
      <Row>
        <Col lg={8}>
          <div className="profileName">{name}</div>
          <div className="Designation">{designation}</div>
        </Col>
        <Col lg={4}>
          <div className="profileLinkedIn">
            <div className="vector_before_linkedin"></div>

            <a href={linkedinUrl} target="_blank" rel="noopener noreferrer">
              <img src={linkedinImg} alt="LinkedIn" />
            </a>
            <span className="nateVideo col-6 col-md-4">
              <img src={playButtonImg} alt="Play Button" />
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
}
